<template>
    <div class="outer-box" v-if="isMounted">
        <div class="left" v-loading="left_loading">
            <div class="student" :style="{'height': clientHeight-70+'px'}">
                <div class="m-portlet m-portlet--creative m-portlet--bordered-semi">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 v-if="!student.current_education" class="m-portlet__head-text">
                                    教育经历未填写
                                </h3>
                                <h3 v-else class="m-portlet__head-text">
                                    {{student.current_education.school.name||'无信息'}} -
                                    {{student.current_education.grade.name||'无信息'}}
                                </h3>
                                <h2 class="m-portlet__head-label m-portlet__head-label--primary"
                                    style="width: 100px;text-align: center;">
                                    <span>{{student.name}}</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__head" style="height: 20px">
                        <h6  class="m-portlet__head-text"> 学号：{{student.id}}</h6>
                    </div>
                    <div class="m-portlet__head" style="height: 20px">
                        <h6  class="m-portlet__head-text"> QQ：{{student.qq||'无'}}</h6>
                    </div>
                    <div class="m-portlet__head" style="height: 20px"  v-if="powers.includes(164) || isHeadTeacher">
                        <h6  class="m-portlet__head-text"> 账号：{{student.account}}</h6>
                    </div>
                    <div class="m-portlet__body m-portlet__body--small-padding" >
                        <el-form label-position="top" label-width="80px">
                            <el-form-item label="班主任" style="width: 150px" >
                                <el-tag type="info"
                                        v-for="headTeacher in student.headTeachers"
                                        :key="headTeacher.id"> {{headTeacher.name}}
                                </el-tag>
                            </el-form-item>
                            <el-form-item label="副班主任" style="width: 150px" >
                                <el-tag type="info"
                                        v-for="secondHeadTeacher in student.secondHeadTeachers"
                                        :key="secondHeadTeacher.id"> {{secondHeadTeacher.name}}
                                </el-tag>
                            </el-form-item>
                            <el-form-item label="学科" v-if="student.subjects" style="width: 150px" >
                                <el-tag type="info"
                                        v-for="subject in student.subjects"
                                        :key="subject.id"
                                        style="margin-right: 5px">
                                    {{subject.name}}
                                </el-tag>
                            </el-form-item>
                            <el-form-item label="学生联系方式">
                                <h6>+86 {{student.phone}}</h6>
                            </el-form-item>
                            <el-form-item label="家长联系方式">
                                <div v-for="parent in student.parents"
                                     :key="parent.id">
                                    <h6 style="margin-top: 10px;margin-bottom: 10px;">{{parent.parent_identity}}：
                                        {{parent.name}}</h6>
                                    <h6 style="margin-top: 10px;margin-bottom: 10px;">手机: +86
                                        {{parent.phone}}</h6>
                                </div>
                            </el-form-item>
                        </el-form>

                        <div class="m-separator m-separator--space m-separator--dashed"></div>
                        <div class="m-b-20">
                            <el-button @click="handleAddClass" v-if="powers.includes(115)">添加班级</el-button>
                            <el-button @click="handleAddAudition" v-if="powers.includes(115)">添加特殊</el-button>
                        </div>
                        <div class="m-b-20">
                            <el-button @click="handleClassHourCart" v-if="powers.includes(115)">购买课时</el-button>
                            <el-button @click="handleShopCart" v-if="powers.includes(115)">周边商城</el-button>
                        </div>
                        <div class="m-b-20">
                            <el-button @click="handleChangeInformation()" v-if="powers.includes(3)">修改信息</el-button>
                            <el-button @click="handleChangePhone()" v-if="powers.includes(164) || isHeadTeacher">修改账号</el-button>
                        </div>
                        <div class="m-b-20">
                            <el-button @click="handleBindAccount()" v-if="powers.includes(164) || isHeadTeacher">绑定账号</el-button>
                            <el-button @click="handleFile()" v-if="isHeadTeacher">学生档案</el-button>
                        </div>
                        <div class="m-b-20">
                            <el-button @click="handleEquipmentLeasing()">设备租赁</el-button>
                            <el-button @click="handleEarnest()">定金</el-button>
                        </div>
                        <!--<div class="m-separator m-separator&#45;&#45;space m-separator&#45;&#45;dashed"></div>-->
                        <!--<div class="m-b-20">-->
                        <!--<el-button @click="handleWeekTable" >周课表</el-button>-->
                        <!--<el-button @click="handleMonthTable">月课表</el-button>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div :style="{'height': 340-heightChange+'px'}" v-if="powers.includes(122)" @click="changeHeight(0)">
                <student-period ref="studentPeriodRef"></student-period>
            </div>

            <div class="m-portlet m-b-0">
                <div class="m-portlet__body" :style="{'height': clientHeight-440+heightChange+'px'}"
                     @click="changeHeight(150)">
                    <el-tabs v-model="activeTab">
                        <el-tab-pane label="课程咨询" name="1" v-if="powers.includes(113)">
                            <student-advisory v-if="activeTab==='1'" ref="studentAdvisoryRef"></student-advisory>
                        </el-tab-pane>
                        <el-tab-pane label="课程记录" name="2" v-if="powers.includes(114)">
                            <studentCourse-record v-if="activeTab==='2'"></studentCourse-record>
                        </el-tab-pane>
                        <el-tab-pane label="课程购买" name="3" v-if="powers.includes(115)">
                            <student-cart v-if="activeTab==='3'" ref="studentCartRef"></student-cart>
                        </el-tab-pane>
                        <el-tab-pane label="未结算合同" name="4" v-if="powers.includes(115)">
                            <noSettlement-invoice v-if="activeTab==='4'" ref="studentCartRef"></noSettlement-invoice>
                        </el-tab-pane>
                        <el-tab-pane label="学生钱包" name="5" v-if="powers.includes(116)">
                            <student-wallet v-if="activeTab==='5'" ref="studentWalletRef"></student-wallet>
                        </el-tab-pane>
                        <el-tab-pane label="回访信息" name="6" v-if="powers.includes(117)">
                            <past-return-visit v-if="activeTab==='6'"></past-return-visit>
                        </el-tab-pane>
                        <el-tab-pane label="教育经历" name="7" v-if="powers.includes(119)">
                            <educational-experiences
                                    v-if="activeTab==='7'"
                                    ref="studentEducationalExperiencesRef"></educational-experiences>
                        </el-tab-pane>
                        <el-tab-pane label="成绩查看" name="8" v-if="powers.includes(120)">
                            <student-score v-if="activeTab==='8'" ref="studentScoreRef"></student-score>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .outer-box {
        .left {
            float: left;
            width: 220px;
            height: 100%;
        }

        .right {
            margin-left: 230px;
            height: 100%;
        }
    }

    .student {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }

        position: absolute;
        overflow: auto;
    }
</style>

<script>
    import StudentPeriod from './StudentPeriod/StudentPeriod.vue'
    import StudentAdvisory from './Advisory/Index.vue';
    import StudentCourseRecord from './CourseRecording/StudentCourseRecord.vue';
    import StudentCart from './Cart/Index.vue';
    import StudentWallet from './Wallet/Index.vue';
    import PastReturnVisit from './ReturnVisit/PastReturnVisit.vue'
    import EducationalExperiences from './EducationalExperiences/Index.vue';
    import SchoolScore from './Score/StudentScore.vue';
    import NoSettlementInvoice from './NoSettlementInvoice/Index.vue';

    export default {
        name: "studentShow",
        data() {
            return {
                canUse: true,
                heightChange: 0,
                dialogVisible: true,
                path: '/student/' + this.$route.params.id,
                isMounted: false,
                loading: true,
                left_loading: true,
                activeTab: '1',
                student_id: 0,
                students: {},
                ops: {
                    rail: {
                        size: '0',
                        gutterOfSide: '0px'
                    },
                    bar: {
                        keepShow: true,
                        background: 'rgba(144, 147, 153, 0.3)'
                    },
                    scrollPanel: {
                        scrollingY: true,
                    }
                },
                initInformation: {
                    grades: {
                        id: '',
                        name: '',
                        status: '',
                        color: '',
                    },
                    headTeachers: {
                        id: '',
                        name: '',
                    },
                    organizationServices: {
                        id: '',
                        name: '',
                        nowSemester_id: '',
                    },
                    parent_identity: [],
                    schoolClasses: {
                        id: '',
                        name: '',
                    },
                    schools: {
                        id: '',
                        name: '',
                        school_type: '',
                        school_level: '',
                        address: '',
                        province_code: '',
                    },
                    star_level: {
                        id: '',
                        name: '',
                        number: '',
                    },
                    subjects: {
                        id: '',
                        name: '',
                        mainJudge: '',
                        color: '',
                    },
                    promotion_channels: {
                        id: '',
                        name: ''
                    }
                },
                student: {
                    id: 0,
                    birthday: '',
                    current_education: {
                        grade: {
                            id: 0,
                            name: '',
                        },
                        school: {
                            id: 0,
                            name: '',
                        },
                        schoolClass: {
                            id: 0,
                            name: '',
                        },
                    },
                    gender_id: 0,
                    headTeacher_id: [],
                    name: '',
                    parents: [],
                    phone: 0,
                    qq: '',
                    referrer_name: '',
                    referrer_type: '',
                    star: '',
                    subjects: [],
                    wechat: [],
                },
                activeName: 'student-advisory',
                employee_id: '',
                copeData: '',
                //Dialog_ChangeInformation
                dialog_ChangeInformation: {
                    button_loading: false,
                    loading: true,
                    title: '更改学生信息',
                    filter: {
                        schools: [],
                        grades: [],
                        hobbies: [],
                        star_level: [],
                        schoolClasses: [],
                        parent_identity: ['父亲', '母亲', '其他'],
                        headTeachers: [],
                    },
                    student: {
                        id: '',
                        birthday: '',
                        current_education: {
                            grade: {
                                id: '',
                                name: '',
                            },
                            school: {
                                id: '',
                                name: '',
                            },
                            schoolClass: {
                                id: '',
                                name: '',
                            },
                        },
                        gender_id: '',
                        headTeachers: [],
                        name: '',
                        parents: [],
                        phone: '',
                        qq: '',
                        referrer_name: '',
                        referrer_type: '',
                        star: '',
                        subjects: [],
                        wechat: [],
                        promotion_channel_ids: [],
                        other_channel_remark: '',
                        conversion:false
                    },
                },
                //StudentPeriod
                studentPeriod: {
                    showPopover: true,
                    studentCartPeriods: [],
                    studentActivePeriods: [],
                    loading: true,
                    activePeriod: {
                        button_loading: false,
                        loading: true,
                        reason: '',
                        status: 'active',
                        options: [

                        ],
                    },
                    //StudentPeriod-AbsentPeriod
                    absentPeriod: {
                        button_loading: false,
                        loading: true,
                        reason: '',
                        status: 'absent',
                    },
                    //StudentPeriod-FinishPeriod
                    finishPeriod: {
                        finishPeriod: [
                            {
                                id: '',
                                content: '',
                                serious_degree: null,
                                note_degree: null,
                                review_degree: null,
                                returnVisit: '1',
                                status: 'finished',
                            }
                        ],
                        openFinishedPeriod: {
                            id: '',
                            content: '',
                            serious_degree: null,
                            note_degree: null,
                            review_degree: null,
                            returnVisit: '1',
                            status: 'finished',
                        },
                        loading: true,
                        classPlanStudent_id: '',
                        button_loading: false,
                    },
                    leavingPeriod: {
                        button_loading: false,
                        title: '缺勤/请假',
                        loading: 'true',
                        applyDetail: '',
                        left: 'left',
                    },
                    switchingPeriod: {
                        loading: true,
                        message: '',
                    },
                    applyReasons: {
                        button_loading: false,
                        title: '缺勤/请假',
                        loading: 'true',
                        applyDetail: new Object(),
                        applyDetails:[],
                        left: 'left',
                    },
                    studentPeriodStyles: [],
                    historyPeriods: [],
                },
                //StudentCart
                studentCart: {
                    button_loading: false,
                    select_loading: false,
                    studentCartData: {},
                    studentCartClassHourData: {},
                    studentCartShopData: {},
                    loading: true,
                    innerVisible: false,
                    settleCheck: true,
                    installCheck: true,
                    sumPay: 0,
                    chosenCart: [],
                    chosenClassHourCart: [],
                    chosenShopCart: [],
                    discountChange: false,
                    settleJudge: true,
                    installmentJudge: false,
                    cart_use_lessons: [],
                    studentCart_classPlans: [],
                    invoiceForm: {
                        student_id: '',
                        parent_id: '',
                        payment_types: [
                            {balance: ''}

                        ]
                    },
                    dialog_ChooseCoupon: {
                        button_loading: false,
                        title: '优惠券',
                        loading: true,
                        studentCoupons: {
                            id: '',
                            money: '',
                            status: false,
                        },
                        coupon_ids: [],
                    },
                    dialog_ChooseWanTuoClassPlan: {
                        loading: 'true',
                        button_loading: false,
                        today: '',
                        pickerOptions0: {
                            disabledDate(time) {
                                let firstDate = new Date();
                                firstDate.setDate(1); //第一天
                                let endDate = new Date(firstDate);
                                endDate.setMonth(firstDate.getMonth() + 1);
                                endDate.setDate(0);
                                return time.getTime() < firstDate.setDate(0) || time.getTime() > endDate;
                            }
                        },
                        index: '',
                    },
                    dialog_DiscountType: {
                        canUseDiscounts: true,
                        discountTypes: {},
                        standbyDiscountTypes: {},
                        discountType_details: {},
                        selfDiscount: {},
                        selfCashDiscounts: 0,
                        selfOfflineCashDiscounts:0,
                        selfOnlineCashDiscounts:0,

                        installmentSelfCashDiscounts: 0,
                        discounts: [],
                        selfDiscounts: 0,
                        selfCashDiscount: 0,
                        selfOfflineCashDiscount: 0,
                        selfOnlineCashDiscount: 0,
                        button_loading: false,
                        loading: true,
                    },
                    dialog_ChooseLesson: {
                        button_loading: false,
                        loading: true,
                        ddd: '',
                        studentLessons: [],
                        studentCarts: [],
                    },
                    dialog_ChooseClassPlan: {
                        loading: true,
                        button_loading: false,
                        studentCartClassPlan_id: 1,
                        status: '',
                    },
                    dialog_DiscountCourse: {
                        title: '优惠信息',
                        loading: true,
                        button_loading: false,
                        discountFilter: {
                            discount: 10,
                            giving_period: 0,
                            possible_auditions_period: 0,
                            discount_reason: ''
                        },

                    },
                    dialog_DiscountClassHour: {
                        title: '优惠信息',
                        loading: true,
                        button_loading: false,
                        discountFilter: {
                            discount: 10,
                            giving_period: 0,
                            possible_auditions_period: 0,
                            discount_reason: ''
                        },
                    },
                    dialog_DiscountShop: {
                        title: '优惠信息',
                        loading: true,
                        button_loading: false,
                        discountFilter: {
                            discount: 10,
                            giving_period: 0,
                            possible_auditions_period: 0,
                            discount_reason: ''
                        },
                    },
                    dialog_HasTime: {
                        button_loading: false,
                        title: '占用时间',
                        hasTime: '',
                    },
                    dialog_Installment: {
                        title: '分期比例',
                        button_loading: false,
                        loading: true,
                        proportion: '',
                    },
                    //使用课次
                    dialog_UseClassHour: {
                        semesters: [],
                        studentClassHours: [],
                        filters: [
                            {
                                semester_id: '',
                                has_period: '',
                                use_period: '',
                            }
                        ]
                    },
                    dialog_SettleAccounts:{
                        payments:[{
                            id:1,
                            paymentType_id:5,
                            balance:0,
                            status:'finished',
                            bill_url:'',
                            canDel:false
                        }],
                        studentDeposits:[],
                        payUrl:''
                    }
                },
                //studentAdvisory
                studentAdvisory: {
                    advisory: {
                        subject: {
                            name: '',
                        }
                    },
                    currentPage: 1,
                    currentPageSize: 10,
                    total: 0,
                    loading: true,
                    returnVisit_id: '',
                    status: '',
                    page: '',
                    page1: '',
                    button_loading: false,
                    filter: {
                        grades: [],
                        subjects: []
                    },
                    dialog_AddAdvisory: {
                        loading: true,
                        isDisabled: true,
                        addAdvisoryDialog: false,
                        button_loading: false,
                        insertForm: {
                            impression: '',
                            grade_id: '',
                            subject_id: [],
                            classType_id: '',
                            content: '',
                            status: ''
                        },
                        filter: {
                            grades: [],
                            subjects: [],
                            status: [
                                {
                                    id: 'active',
                                    name: '咨询'
                                },
                                {
                                    id: 'cancel',
                                    name: '取消'
                                },
                                {
                                    id: 'chase',
                                    name: '待结算'
                                },
                                {
                                    id: 'finish',
                                    name: '完成'
                                }]
                        },
                    },
                    dialog_ShowAdvisory: {
                        title: '咨询信息详情',
                        button_loading: false,
                        loading: true,
                        advisoryDetail: {
                            id: '',
                            impression: '',
                            grade_id: '',
                            classType_id: '',
                            subject_id: '',
                            content: '',
                            status: ''
                        },
                        filter: {
                            grades: [],
                            subjects: [],
                            status: [{
                                id: 'active',
                                name: '咨询'
                            },
                                {
                                    id: 'cancel',
                                    name: '取消'
                                },
                                {
                                    id: 'chase',
                                    name: '待结算'
                                },
                                {
                                    id: 'finish',
                                    name: '完成'
                                }]
                        },
                    },
                },
                //studentCourseRecord
                studentCourseRecord: {
                    courseRecord: 1,
                    activeTab: '1',
                    loading: true,
                    studentActivePeriods: [{
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    }],
                    studentFinishedPeriods: {
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    },
                    studentCancelPeriods: {
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    },
                    studentInvoice: {
                        loading: false,
                        invoiceDetail: false,
                        invoiceDetail_val: {},
                        anotherInvoiceDetail_val: {
                            id: ''
                        },
                        paymentType: {
                            money: '',
                            zfb: '',
                            wx: '',
                            bank: '',
                            discount: '',
                            balance: ''
                        },
                        studentInvoices: [],
                        invoices: {},
                        page: '',
                    },
                    studentEarnestInvoices:[],
                    studentHistoryPeriod: {
                        studentActivePeriods: {},
                        studentPeriodStyles: [
                            {
                                name: '未上',
                                color: 'rgba(216,216,216)'
                            },
                            {
                                name: '签到',
                                color: '#D2EAB9'
                            },
                            {
                                name: '缺席',
                                color: '#946767'
                            },
                            {
                                name: '调课',
                                color: '#81AEE4'
                            },
                            {
                                name: '旷课',
                                color: '#E77E7E'
                            },
                            {
                                name: '请假',
                                color: 'rgba(133,214,225,1)'
                            },
                            {
                                name: '退费',
                                color: '#F5A77C'
                            },
                            {
                                name: '待购',
                                color: 'rgba(204,204,0,1)'
                            },
                            {
                                name: '未买',
                                color: '#898989'
                            },
                            {
                                name: '分期',
                                color: 'rgb(213,42,136)'
                            }
                        ],
                        rectH: 70 * 2,
                        row: '1',
                        loading: true,
                        // studentActivePeriods: [],
                        // studentCartPeriods: [],
                    },
                    dialog_CancelCourse: {
                        title: '取消课程',
                        button_loading: false,
                        loading: true,
                        studentPeriod: {
                            id: '',
                            unit_period_price: '',
                        },
                        retire_period: '',
                        reason: '',
                        reason_id: '',
                    },
                    dialog_ChangeCourse: {
                        title: '更换课程',
                        loading: true,
                        studentPeriod: {
                            id: '',
                            unit_period_price: '',
                        },
                        button_loading: false,
                        retire_period: '',
                        reason: '',
                        reason_id: '',
                    },
                },
                //studentWallet
                studentWallet: {
                    activeTab: "1",
                    hasMoney: '',
                    disputeMoney: '',
                    couponMoney: '',
                    sum_offline_cashCoupon:'',
                    sum_online_cashCoupon:'',
                    sum_cashCoupon: '',
                    sum_deposit:'',
                    sum_earnest:'',
                    all_online_period:0,
                    loading: true,
                    studentBalances: {
                        id: '',
                        created_at: '',
                        payment_type: {
                            name: ''
                        },
                        remark: '',
                        balance: '',
                    },
                    studentPeriods: {
                        id: '',
                        grade: '',
                        subject: '',
                        class_type: '',
                        created_at: '',
                        period: '',

                    },
                    studentCoupons: {
                        id: '',
                        getDate: '',
                        endDate: '',
                        money: '',
                        remark: '',
                    },
                    cashCoupons: {
                        id: '',
                        start_date: '',
                        end_date: '',
                        balance: '',
                        status: ''
                    },
                    discountCoupons: {
                        id: '',
                        start_date: '',
                        end_date: '',
                        discount: '',
                        status: ''
                    },
                    studentClassHours: {
                        id: '',
                        semester_name: '',
                        grade_name: '',
                        subject_name: '',
                        class_type_name: '',
                        time: '',
                        original_unit_period_price: '',
                        unit_period_price: '',
                        period: '',
                        sum_price: ''
                    },
                    studentShops: {
                        id: '',
                        shop_name: '',
                        original_unit_price: '',
                        discount: '',
                        unit_price: '',
                        amount: '',
                        sum_price: '',
                    },
                    dialog_WallAddCash: {
                        button_loading: false,
                        title: '等待付款',
                        loading: true,
                        paymentTypeJudge: false,
                        settleForm: [],
                        remark: '',
                        labelPosition: 'center',
                    },
                    dialog_LessonRetired: {
                        button_loading: false,
                        loading: true,
                        studentLessons: [],
                    },
                    dialog_ClassHourRetired: {
                        button_loading: false,
                        loading: true,
                        studentClassHours: [],
                    },
                    dialog_ClassHourChange: {
                        button_loading: false,
                        loading: true,
                        dialogVisible:false,
                        next_semesters:[]
                    },
                    dialog_UpdateCashCoupon: {
                        button_loading: false,
                        loading: true,
                    },
                    dialog_BalanceDetail: {
                        showInvoiceRefund: false,
                        loading: false,
                        balanceDetails: [],
                        invoiceRefunds: [],
                    },
                },
                //PastReturnVisit
                pastReturnVisit: {
                    returnVisit: {
                        head_teacher: {
                            employee: {
                                name: ''
                            }
                        },
                        parent: {
                            name: ''
                        }
                    },
                    student: {
                        name: ''
                    },
                    visualDetail: false,
                    currentPage: 1,
                    currentPageSize: 10,
                    parentsName: '',
                    returnVisitor: '',
                    complaintsDate: '',
                    total: 0,
                    loading: true,
                    button_loading: false,
                    dialog_PastReturnDetail: {
                        detailData: [],
                        loading: true,
                    }
                },
                //StudentParentalComplaints
                studentParentalComplaints: {
                    loading: true,
                    button_loading: false,
                    parentalComplaints: new Object(),
                    page: '',
                    page1: '',
                    total: 10,
                    currentPage: 1,
                    currentPageSize: 10
                },
                //EducationalExperiences
                studentEducationalExperiences: {
                    loading: true,
                    button_loading: false,
                    page: '',
                    page_id: '',
                    page1: '',
                    total: 10,
                    currentPage: 1,
                    currentPageSize: 10,
                    educationalExperiences: {
                        id: '',
                        school: {
                            name: ''
                        },
                        school_year: '',
                        graduated_at: '',
                        grade: {
                            name: ''
                        },
                        schoolClass: {
                            name: ''
                        },
                    },
                    filter: {
                        schools: [],
                        hobbies: [],
                        parent_identity: [],
                        grades: [],
                        schoolClasses: [],
                    },
                    dialog_StudentAddEducationalExperiences: {
                        title: '添加学生教育信息',
                        button_loading: false,
                        school_status: true,
                        loading: true,
                        addAdvisoryDialog: false,
                        educationalExperiencesForm: {
                            school_id: '',
                            school_year: '',
                            graduated_at: '',
                            defined_school: '',
                            schoolClass_id: '',
                            grade_id: '',
                        }
                    },
                    dialog_StudentEducationalExperiencesDetail: {
                        title: '教育经历详情',
                        button_loading: false,
                        loading: true,
                        school_status: true,
                        educationalExperiencesDetail: {
                            school_id: '',
                            school_year: '',
                            graduated_at: '',
                            defined_school: '',
                            grade_id: '',
                            schoolClass_id: ''
                        }

                    },
                },
                //schoolScore
                schoolScore: {
                    loading: true,
                    subjectCheck: false,
                    resultView: '',
                    page: '',
                    activeTab: '1',
                    disableYN: false,
                    organizationServiceScores: [],
                    schoolScores: {
                        schoolExam: {
                            name: '',
                            date: '',
                            schoolClass: '',
                            mainScore: '',
                            sumScore: '',
                            sumClassRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                            mainClassRank: '',
                            hasLook: '',
                            studentSchoolScores: {
                                score: '',
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                                examSubject: {
                                    subject: {
                                        name: '',
                                    },
                                    totalScore: '',
                                    gradeAvgScore: '',
                                    areaAvgScore: '',
                                },
                                school_exam_school_class: {
                                    mainClassAvgScore: '',
                                    sumClassAvgScore: '',
                                    classAvgScore: '',
                                },
                            },
                            schoolExam: {
                                mainGradeAvgScore: '',
                                mainAreaAvgScore: '',
                                sumGradeAvgScore: '',
                                sumAreaAvgScore: '',
                            },
                            school_exam_school_class: {
                                mainClassAvgScore: '',
                                sumClassAvgScore: '',
                                classAvgScore: '',
                            },
                            grade: {
                                name: '',
                            },
                        }
                    },
                    dialog_UpdateMainSchoolScore: {
                        button_loading: false,
                        student_schoolExam: {
                            name: '',
                            date: '',
                            school: {
                                name: ''
                            },
                            grade: {
                                name: ''
                            },
                            school_exams: {
                                name: '',
                                date: '',
                            },
                            schoolExam_schoolClass_id: '',
                            mainScore: '',
                            sumScore: '',
                            mainClassRank: '',
                            mainGradeRank: '',
                            mainAreaRank: '',
                            sumClassRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                            schoolScores: {
                                school_exam_subject: {
                                    subject: {
                                        name: ''
                                    },
                                },
                                score: '',
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                            },
                        },
                        schoolClasses: {
                            id: '',
                            name: '',
                        },
                    },
                    dialog_AddSchoolScore: {
                        title: '添加学校成绩',
                        button_loading: false,
                        loading: true,
                        subjectCheck: false,
                        school_val: {
                            schoolExams: [],
                            examSubjects: []
                        },
                        outlineForm: {
                            schoolClass_id: '',
                            grade_id: '',
                            school_id: '',
                            school_name: '',
                            schoolExam_id: '',
                            schoolExam_name: '',
                            examDate: '',
                            mainClassRank: '',
                            sumClassRank: '',
                            mainGradeRank: '',
                            mainAreaRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                        },
                        grades: '',
                        subjects: '',
                        exam_status: true,
                        // schoolScores: [],
                        schoolClasses: [],
                    },
                },
                //Invoice
                dialog_InvoiceDetail: {
                    loading: true,
                    invoiceDetail_val: {
                        invoiceItems: [
                            {
                                semester: {
                                    name: ''
                                },
                                classx: {
                                    name: '',
                                    class_type_name: '',
                                },
                                section: {
                                    name: ''
                                },
                                teacher_name: '',
                                start_time: '',
                                period: '',
                                original_unit_period_price: '',
                                discount: '',
                                sum_price: '',
                                versionNumber: '',
                                proportion: '',
                            }
                        ],
                        studentPayment: [{
                            id: '',
                            invoice_id: '',
                            balance: '',
                            payment_type: {
                                id: '',
                                name: '',
                            },
                            payment_type_id: '',
                            remark: '',
                            student_id: '',
                        }],
                        student_name: '',
                        student_school: '',
                        student_grade: '',
                        parent_name: '',
                        student_phone: '',
                        parent_phone: '',
                        hasPay: '',
                        type: '',
                        id: '',
                        version: '',
                    },
                    anotherInvoiceDetail_val: {
                        invoiceItem_shops: [
                            {
                                shop_name: '',
                                amount: '',
                                original_unit_price: '',
                                discount: '',
                                sum_price: '',
                            }
                        ],
                        invoiceItem_classHours: [
                            {
                                semester_name: '',
                                grade_name: '',
                                subject_name: '',
                                class_type_time: '',
                                time: '',
                                period: '',
                                original_unit_period_price: '',
                                discount: '',
                                sum_price: '',
                            }
                        ],
                        studentPayment: [{
                            id: '',
                            invoice_id: '',
                            balance: '',
                            payment_type: {
                                id: '',
                                name: '',
                            },
                            payment_type_id: '',
                            remark: '',
                            student_id: '',
                        }],
                        student_name: '',
                        student_school: '',
                        student_grade: '',
                        parent_name: '',
                        student_phone: '',
                        parent_phone: '',
                        hasPay: '',
                        type: '',
                        id: '',
                        version: '',
                    },
                    leaseInvoiceDetail_val:{},
                    hasMoney: 0,
                    zfb: 0,
                    wetChat: 0,
                    bank: 0,
                    cash: 0,
                    discount: 0,
                    headTeacherLimit: 0,
                    periodUse: 0,
                    periodLklBank: 0,
                    periodLklWetChat: 0,
                    periodLklZfb: 0,
                    coupon: 0,
                    showOn: false,
                    printOn: true,
                    maxHeight: 800,
                },
                dialog_InvoiceBill: {
                    loading: false,
                    invoiceBills: [],
                    invoiceBillsLength: 0,
                },
                //课表的内容
                V4Judge: false,
                dialog_ChooseClass_loading: true,
                studentCarts: {},
                modalData: {},
                gradesInfo: {},
                semesters: {},
                timeData: {},
                teachers: {},
                subjects: [],
                classes: [],
                class_student: {},
                currentUsers: {},
                class_types: {},
                type: '',
                start_date: '',
                crunkView: false,
                disableType: false,
                note: '',
                tempLength: 0,
                isHeadTeacher: false,
                cell: {
                    selectable: false,
                    rect: [0, 0, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id: '',
                    draggable: false,
                },
                teacherCell: {
                    selectable: false,
                    rect: [0, 1, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id: '',
                    draggable: false,
                },
                filter: {
                    semester_id: this.$store.state.config.nowSemester.id,
                    grade_id: [],
                    date:'',
                    section_id:this.$store.state.config.section.id,
                },
                showStudent: false,
                pluralClasses: {
                    viewJudge: false,
                    index: 0,
                    classes: [],
                    height: 50 * window.devicePixelRatio,
                },
                //学期
                scroll: {
                    left: 0,
                    top: 0
                },

                //dialogs
                classrooms: {},
                dialog_CreateClass_Semester: {
                    loading: false,
                    button_loading: false,
                    cartTableDialogVisible: false,
                    course: {},
                    courses: {},
                    search_loading: false,
                    classForm: {
                        name: '',
                        type: '',
                        classroom_id: '',
                        note: '',
                        subject_id: 0,
                        teacher_id: 0,
                        template_time_id: '',
                        template_time_semester_id: 0,
                        semester_id: 0,
                        class_type_id: 0,
                        grade_id: 0,
                        period: 0,
                        unit_period_price: 0,
                        start_date: '',
                        nightClass: false,
                        unit_classHour: 1,
                    }
                },
                timeTable: {
                    V4titleW: 100 * window.devicePixelRatio,
                    V4titleH: 50 * window.devicePixelRatio,
                    V4leftTimeW: 120 * window.devicePixelRatio,
                    V4rectW: 100 * window.devicePixelRatio,
                    V4rectH: 50 * window.devicePixelRatio,
                    V4ratio: window.devicePixelRatio,
                    V4divi: 2,
                },
                studentWeekTable: {
                    loading: true,
                    V4Judge: false,
                    V4Show: false,
                    showStudent: false,
                    weeks: [],
                    basisTime: [],
                    classes: [],
                    class_student: {},
                    scroll: {
                        left: 0,
                        top: 0
                    },
                    filter: {
                        grade_id: [],
                        date: this.$moment().format('YYYY-MM-DD')
                    },
                    startTime: 8,
                },
                dialog_classHourCart: {
                    filter: {
                        semester_id: '',
                        grade_id: '',
                        time: '',
                        unit_price: '',
                        classHour_id: '',
                        period: 0,
                        sum_price: 111,
                    },
                    classHours: {},
                    semesters: [],
                    grades: [],
                    times: [
                        {
                            id: 1,
                            name: 1
                        },
                        {
                            id: 2,
                            name: 1.5
                        }
                    ],
                },
                dialog_shopCart: {
                    filter: {
                        shop_id: '',
                        unit_price: '',
                        amount: 0,
                        rentToBuy:false,
                        rent_shop_id:''
                    },
                    student_rent_shops:[],
                    shops: [],
                },
                dialog_ChangeStudentPhone:{
                    phone:'',
                    new_phone:'',
                    button_loading:false,
                },
                dialog_TryingCart:{
                    tryingCarts:[],
                    loading:false,
                    button_loading:false,
                },
                NoSettlementInvoice:{
                    settlementInvoices:[],
                    dialog_settlementInvoiceDetail:{
                        carts:[],
                        discounts:[],
                        cashDiscounts:[],
                        otherDiscounts:[],
                    },
                },
                equipmentLeasing:{
                    title:'',
                    type:'',
                    dialogVisible:false,
                    settleDialogVisible:false,
                    cartShops:[],
                    checked:false,
                    paymentTypes:[],
                    dialog_settlement:{
                        sumPay:0,
                        parent_id:'',
                        payments:[],
                        button_loading:false
                    }
                },
                earnest:{
                    title:'',
                    type:'',
                    dialogVisible:false,
                    settleDialogVisible:false,
                    cartShops:[],
                    checked:false,
                    paymentTypes:[],
                    dialog_settlement:{
                        sumPay:0,
                        parent_id:'',
                        payments:[],
                        remark:'',
                        prefix:'',
                        button_loading:false
                    }
                }
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight;
            },
            powers() {
                return this.$store.state.config.powers;
            },
            grades() {
                for (let i in this.gradesInfo) {
                    if (this.gradesInfo[i].name === '毕业') {
                        this.$delete(this.gradesInfo, this.gradesInfo[i].id);
                    }
                }
                return this.gradesInfo;
            },
        },
        components: {
            'student-period': StudentPeriod,
            'student-advisory': StudentAdvisory,
            'studentCourse-record': StudentCourseRecord,
            'student-cart': StudentCart,
            'student-wallet': StudentWallet,
            'past-return-visit': PastReturnVisit,
            // 'student-parentalComplaints': StudentParentalComplaints,
            'educational-experiences': EducationalExperiences,
            'student-score': SchoolScore,
            'noSettlement-invoice':NoSettlementInvoice
        },
        mounted() {
            this.student.id = this.$route.params.id;
            this.isMounted = true;
        },
        created() {
            this.handleCreate();
            this.handleShowStudent();
            this.handleGetInitInformation();
        },
        beforeDestroy() {
            this.$wApi.removeListen(this.path)
        },
        methods: {
            changeHeight(height) {
                if (this.clientHeight <= 768) {
                    this.heightChange = height;
                } else {
                    this.heightChange = 0;
                }
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShowStudent() {
                this.student_id = this.$route.params.id;
                this.$wApi.send(this.path, 'show', {
                    'student_id': this.$route.params.id
                });
            },
            handleGetInitInformation() {
                this.$wApi.send(this.path, 'initStudentInformation');
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'show':
                        this.student = data.student;
                        this.dialog_ChangeInformation.student = JSON.parse(JSON.stringify(data.student));
                        this.dialog_ChangeInformation.student.headTeachers = [];
                        this.dialog_ChangeInformation.student.subjects = [];
                        JSON.parse(JSON.stringify(data.student.headTeachers)).forEach((item) => {
                            this.dialog_ChangeInformation.student.headTeachers.push(item.id)
                        });
                        JSON.parse(JSON.stringify(data.student.subjects)).forEach((item) => {
                            this.dialog_ChangeInformation.student.subjects.push(item.id);
                        });
                        // this.loading = false;
                        this.left_loading = false;
                        this.isHeadTeacher = data.isHeadTeacher;
                        break;
                    case 'courseStatusSure':
                        this.$notify({
                            title: '成功',
                            message: '确认成功',
                            type: 'success'
                        });
                        break;
                    case 'studentPeriod':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.studentPeriod.loading = false;
                        break;
                    case 'refreshStudentPeriod':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.studentPeriod.loading = false;
                        break;
                    case 'finishedPeriod':
                        this.studentPeriod.historyPeriods = data.studentPeriod;
                        this.studentPeriod.loading = false;
                        break;
                    case 'get_student_carts':
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        if (Object.keys(data.studentCart_classHours).length !== 0) {
                            this.studentCart.studentCartClassHourData = data.studentCart_classHours;
                        } else {
                            this.studentCart.studentCartClassHourData = new Object();
                        }
                        if (Object.keys(data.studentCart_shops).length !== 0) {
                            this.studentCart.studentCartShopData = data.studentCart_shops;
                        } else {
                            this.studentCart.studentCartShopData = new Object();
                        }
                        this.studentCart.invoiceForm.payment_types = data.paymentTypes;
                        this.studentCart.loading = false;
                        break;
                    case 'studentAdvisory':
                        if (Object.keys(data.studentAdvisory).length !== 0) {
                            this.studentAdvisory.advisory = data.studentAdvisory
                        } else {
                            this.studentAdvisory.advisory = new Object();
                        }
                        this.studentAdvisory.total = data.total;
                        this.studentAdvisory.loading = false;
                        break;
                    case 'deleteStudentAdvisory':
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        if (Object.keys(data.studentAdvisory).length !== 0) {
                            this.studentAdvisory.advisory = data.studentAdvisory
                        } else {
                            this.studentAdvisory.advisory = new Object();
                        }
                        this.studentAdvisory.total = data.studentAdvisory.total;
                        this.studentAdvisory.button_loading = false;
                        break;
                    case 'deleteStudentAdvisoryError':
                        this.studentAdvisory.button_loading = false;
                        break;
                    case 'get_classPlanStatus':
                        this.studentPeriod.studentPeriodStyles = data.classPlanStatus;
                        break;
                    case 'get_leaveReason':
                        this.studentPeriod.leavingPeriod.applyDetail = data.studentApply;
                        break;
                    case 'get_leavingReason':
                        this.studentPeriod.leavingPeriod.reason = data.reason;
                        break;
                    case 'get_refundReason':
                        this.studentPeriod.leavingPeriod.applyDetail = data.studentApply;
                        break;
                    case 'get_applyReason':
                        // this.studentPeriod.applyReasons.applyDetails = new Object();
                        // this.$set(this.studentPeriod.applyReasons.applyDetails, data.studentApply.id, data.studentApply);
                        this.studentPeriod.applyReasons.applyDetails=data.studentApplys
                        // this.$set(this.studentPeriod.applyReasons.applyDetail.loading, data.studentApply.id, false);
                        break;
                    case 'studentCourseRecord':
                        if (Object.keys(data.studentPeriod_active).length !== 0) {
                            this.studentCourseRecord.studentActivePeriods = data.studentPeriod_active
                        } else {
                            this.studentCourseRecord.studentActivePeriods = new Object();
                        }
                        if (Object.keys(data.studentPeriod_finished).length !== 0) {
                            this.studentCourseRecord.studentFinishedPeriods = data.studentPeriod_finished
                        } else {
                            this.studentCourseRecord.studentFinishedPeriods = new Object();
                        }
                        if (Object.keys(data.studentPeriod_cancel).length !== 0) {
                            this.studentCourseRecord.studentCancelPeriods = data.studentPeriod_cancel
                        } else {
                            this.studentCourseRecord.studentCancelPeriods = new Object();
                        }
                        this.studentCourseRecord.loading = false;
                        break;
                    case 'schoolScore':
                        if (Object.keys(data.student_schoolExams).length !== 0) {
                            this.schoolScore.schoolScores = data.student_schoolExams
                        } else {
                            this.schoolScore.schoolScores = new Object();
                        }
                        // if (Object.keys(data.organizationServiceScores).length !== 0) {
                        //     this.schoolScore.organizationServiceScores = data.organizationServiceScores
                        // } else {
                        //     this.schoolScore.organizationServiceScores = new Object();
                        // }
                        this.schoolScore.loading = false;
                        break;
                    case 'studentWallet':
                        if (Object.keys(data.studentBalances).length !== 0) {
                            this.studentWallet.studentBalances = data.studentBalances
                        } else {
                            this.studentWallet.studentBalances = new Object();
                        }
                        if (Object.keys(data.studentLessons).length !== 0) {
                            this.studentWallet.studentPeriods = data.studentLessons
                        } else {
                            this.studentWallet.studentPeriods = new Object();
                        }
                        if (Object.keys(data.studentCoupons).length !== 0) {
                            this.studentWallet.studentCoupons = data.studentCoupons
                        } else {
                            this.studentWallet.studentCoupons = new Object();
                        }
                        if (Object.keys(data.cashCoupons).length !== 0) {
                            this.studentWallet.cashCoupons = data.cashCoupons
                        } else {
                            this.studentWallet.cashCoupons = new Object();
                        }
                        if (Object.keys(data.discountCoupons).length !== 0) {
                            this.studentWallet.discountCoupons = data.discountCoupons
                        } else {
                            this.studentWallet.discountCoupons = new Object();
                        }
                        if (Object.keys(data.studentClassHours).length !== 0) {
                            this.studentWallet.studentClassHours = data.studentClassHours
                        } else {
                            this.studentWallet.studentClassHours = new Object();
                        }
                        if (Object.keys(data.studentShops).length !== 0) {
                            this.studentWallet.studentShops = data.studentShops
                        } else {
                            this.studentWallet.studentShops = new Object();
                        }
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.disputeMoney = data.disputeMoney;
                        this.studentWallet.couponMoney = data.couponMoney;
                        this.studentWallet.sum_offline_cashCoupon = data.sum_offline_cashCoupon;
                        this.studentWallet.sum_online_cashCoupon = data.sum_online_cashCoupon;
                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.studentWallet.sum_deposit = data.sum_deposit;
                        this.studentWallet.sum_earnest = data.sum_earnest;
                        this.studentWallet.all_online_period = data.all_online_period;
                        this.studentWallet.loading = false;
                        break;
                    case 'pastReturnVisit':
                        if (Object.keys(data.returnVisit).length !== 0) {
                            this.pastReturnVisit.returnVisit = data.returnVisit
                        } else {
                            this.pastReturnVisit.returnVisit = new Object();
                        }
                        this.pastReturnVisit.total = data.total;
                        this.pastReturnVisit.loading = false;
                        break;
                    case 'pastReturnVisitCheckReturn':
                        this.pastReturnVisit.dialog_PastReturnDetail.detailData = data.pastReturnVisitCheckReturn.detailData;
                        switch (this.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id) {
                            case 1:
                                this.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id = 5;
                                break;
                            case 2:
                                this.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id = 3;
                                break;
                            case 4:
                                this.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id = 2;
                                break;
                            case 5:
                                this.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id = 1;
                                break;
                            default:
                                break;
                        }
                        this.pastReturnVisit.dialog_PastReturnDetail.loading = false;
                        break;
                    case 'pastReturnVisitShowReturnVisit':
                        if (Object.keys(data.returnVisit).length !== 0) {
                            this.pastReturnVisit.returnVisit = data.pastReturnVisitShowReturnVisit.returnVisit
                        } else {
                            this.pastReturnVisit.returnVisit = new Object();
                        }
                        this.pastReturnVisit.total = data.pastReturnVisitShowReturnVisit.total;
                        break;
                    case 'studentParentalComplaints':
                        if (Object.keys(data.studentParentalComplaints).length !== 0) {
                            this.studentParentalComplaints.parentalComplaints = data.studentParentalComplaints.studentParentalComplaints;
                        } else {
                            this.studentParentalComplaints.parentalComplaints = new Object();
                        }
                        this.studentParentalComplaints.total = data.studentParentalComplaints.total;
                        this.studentParentalComplaints.loading = false;
                        break;
                    case 'showParentalComplaints':
                        if (Object.keys(data.studentParentalComplaints).length !== 0) {
                            this.studentParentalComplaints.parentalComplaints = data.showParentalComplaints.studentParentalComplaints;
                        } else {
                            this.studentParentalComplaints.parentalComplaints = new Object();
                        }
                        this.studentParentalComplaints.total = data.showParentalComplaints.total;
                        this.studentParentalComplaints.loading = false;
                        break;
                    case 'studentEducationalExperiences':
                        this.studentEducationalExperiences.educationalExperiences = data.studentEducationalExperiences;
                        this.studentEducationalExperiences.total = data.total;
                        this.studentEducationalExperiences.loading = false;
                        break;
                    case 'activeAndAbsentClass':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.absentPeriod.button_loading = false;
                        this.studentPeriod.activePeriod.button_loading = false;
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        break;
                    case 'activeAndAbsentClassError':
                        this.studentPeriod.activePeriod.button_loading = false;
                        this.studentPeriod.absentPeriod.button_loading = false;
                        break;
                    case 'get_studentClassPlan_to_otherClassPlan':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        break;
                    case 'get_studentClassPlan_to_newClassPlan':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        break;
                    case 'showFinishedPeriod':
                        this.studentPeriod.finishPeriod.finishPeriod.push({
                            id: this.studentPeriod.finishPeriod.classPlanStudent_id,
                            content: data.showFinishedPeriod.content,
                            serious_degree: data.showFinishedPeriod.serious_degree,
                            note_degree: data.showFinishedPeriod.note_degree,
                            review_degree: data.showFinishedPeriod.review_degree,
                            returnVisit: '1',
                            status: 'finished',
                        });
                        this.studentPeriod.finishPeriod.openFinishedPeriod = {
                            id: this.studentPeriod.finishPeriod.classPlanStudent_id,
                            content: data.showFinishedPeriod.content,
                            serious_degree: data.showFinishedPeriod.serious_degree,
                            note_degree: data.showFinishedPeriod.note_degree,
                            review_degree: data.showFinishedPeriod.review_degree,
                            returnVisit: '1',
                            status: 'finished',
                        };
                        this.studentPeriod.finishPeriod.loading = false;
                        break;
                    case 'storeFinishedPeriod':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.finishPeriod.button_loading = false;
                        for (let i = 0; i < Object.keys(this.studentPeriod.finishPeriod.finishPeriod).length; i++) {
                            if (this.studentPeriod.finishPeriod.finishPeriod[i].id === this.studentPeriod.finishPeriod.openFinishedPeriod.id) {
                                this.studentPeriod.finishPeriod.finishPeriod[i].content = this.studentPeriod.finishPeriod.openFinishedPeriod.content;
                                this.studentPeriod.finishPeriod.finishPeriod[i].serious_degree = this.studentPeriod.finishPeriod.openFinishedPeriod.serious_degree;
                                this.studentPeriod.finishPeriod.finishPeriod[i].note_degree = this.studentPeriod.finishPeriod.openFinishedPeriod.note_degree;
                                this.studentPeriod.finishPeriod.finishPeriod[i].review_degree = this.studentPeriod.finishPeriod.openFinishedPeriod.review_degree;
                                this.studentPeriod.finishPeriod.finishPeriod[i].status = this.studentPeriod.finishPeriod.openFinishedPeriod.status;
                                this.studentPeriod.finishPeriod.finishPeriod[i].returnVisit = this.studentPeriod.finishPeriod.openFinishedPeriod.returnVisit;
                            }
                        }
                        break;
                    case 'storeFinishedPeriodError':
                        this.studentPeriod.finishPeriod.button_loading = false;
                        break;
                    case 'add_class_to_specialCart':
                        this.$set(this.studentCart.studentCartData, data.cart.id, data.cart);
                        break;
                    case 'delete_cart':
                        this.studentCart.discountChange = false;
                        Object.keys(this.studentCarts).forEach((item, index) => {
                            if (index === data.sortBy) {
                                this.studentCarts[index][0].name = '';
                                this.studentCarts[index][0].cart_id = '';
                            }
                        });
                        this.studentPeriod.studentActivePeriods[2].forEach((item, index) => {
                            if (item.class_id == data.class_id) {
                                this.studentPeriod.studentActivePeriods[2].splice(index, 1);
                            }
                        });
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        this.$message({
                            type: 'success',
                            message: '移除成功',
                        });
                        this.$forceUpdate();
                        this.studentCart.button_loading = false;
                        break;
                    case 'deleteCartError':
                        this.studentCart.button_loading = false;
                        this.studentCart.discountChange = false;
                        break;
                    case 'checkOutCart':
                        this.$message({
                            message: '结算成功，成功创建合同',
                            type: 'success'
                        });
                        for (let i in this.studentCart.invoiceForm.payment_types) {
                            this.studentCart.invoiceForm.payment_types[i].balance = 0;
                        }
                        //刷新购物车
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        for (let j in data.cart_classHour_ids) {
                            this.$delete(this.studentCart.studentCartClassHourData,data.cart_classHour_ids[j])
                        }
                        for (let k in data.cart_shop_ids) {
                            this.$delete(this.studentCart.studentCartShopData,data.cart_shop_ids[k])
                        }

                        //刷新课程记录
                        if (Object.keys(data.studentCourseRecord).length !== 0) {
                            this.studentCourseRecord.studentActivePeriods = data.studentCourseRecord
                        } else {
                            this.studentCourseRecord.studentActivePeriods = new Object();
                        }
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }
                        if (data.student_discountCoupon) {
                            this.$set(this.studentWallet.discountCoupons, data.student_discountCoupon.id, data.student_discountCoupon)
                        }
                        this.studentCart.settleJudge = false;
                        this.studentCart.button_loading = false;
                        this.$Win.openModal('Dialog_SettleSuccess', 500, 200, '重要提醒', {'invoice_id': data.invoice_id},false,true);
                        break;
                    case 'checkOutCartError':
                        // this.studentCart.settleJudge = false;
                        this.studentCart.button_loading = false;
                        break;
                    case 'deleteMainSchoolScore':
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.schoolScore.button_loading = false;
                        if (Object.keys(data.student_schoolExam.student_schoolExams).length !== 0) {
                            this.schoolScore.schoolScores = data.student_schoolExam.student_schoolExams
                        } else {
                            this.schoolScore.schoolScores = new Object();
                        }
                        if (Object.keys(data.student_schoolExam.organizationServiceScores).length !== 0) {
                            this.schoolScore.organizationServiceScores = data.student_schoolExam.organizationServiceScores
                        } else {
                            this.schoolScore.organizationServiceScores = new Object();
                        }
                        break;
                    case 'showStudentInvoice':
                        if (Object.keys(data.studentInvoices).length !== 0) {
                            this.studentCourseRecord.studentInvoice.studentInvoices = data.studentInvoices;
                        } else {
                            this.studentCourseRecord.studentInvoice.studentInvoices = new Object();
                        }
                        break;
                    case 'showStudentEarnestInvoice':
                        if (Object.keys(data.studentEarnestInvoices).length !== 0) {
                            this.studentCourseRecord.studentEarnestInvoices = data.studentEarnestInvoices;
                        } else {
                            this.studentCourseRecord.studentEarnestInvoices = new Object();
                        }
                        break;
                    // case 'showHistoryPeriods':
                    //     this.studentCourseRecord.studentHistoryPeriod.studentActivePeriods = data.showHistoryPeriods.studentPeriod;
                    //     this.studentCourseRecord.studentHistoryPeriod.row = this.studentActivePeriods[0].length + this.studentActivePeriods[1].length + this.studentActivePeriods[2].length + 1;
                    //     this.studentCourseRecord.studentHistoryPeriod.loading = false;
                    //     break;
                    case 'deleteEducationalExperiences':
                        this.studentEducationalExperiences.button_loading = false;
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.studentEducationalExperiences.educationalExperiences = data.studentEducationalExperiences;
                        this.studentEducationalExperiences.total = data.total;
                        break;
                    case 'deleteEducationalExperiencesError':
                        this.studentEducationalExperiences.button_loading = false;
                        break;
                    case 'leavingPeriod':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        this.studentPeriod.activePeriod.button_loading = false;
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }

                        if (data.studentBalance) {
                            this.$set(this.studentWallet.studentBalances, data.studentBalance.id, data.studentBalance)
                        }

                        if (data.studentLesson) {
                            this.$set(this.studentWallet.studentLessons, data.studentLesson.id, data.studentLesson)
                        }

                        if (data.studentCoupon) {
                            this.$set(this.studentWallet.studentCoupons, data.studentCoupon.id, data.studentCoupon)
                        }

                        if (data.studentClassHour) {
                            this.$set(this.studentWallet.studentClassHours, data.studentClassHour.id, data.studentClassHour)
                        }

                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.disputeMoney = data.disputeMoney;
                        this.studentWallet.couponMoney = data.couponMoney;
                        break;
                    case 'leavingPeriodError':
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        this.studentPeriod.activePeriod.button_loading = false;
                        break;
                    case 'askForApplyPeriod':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }

                        if (data.studentBalance) {
                            this.$set(this.studentWallet.studentBalances, data.studentBalance.id, data.studentBalance)
                        }

                        if (data.studentLesson) {
                            this.$set(this.studentWallet.studentLessons, data.studentLesson.id, data.studentLesson)
                        }

                        if (data.studentCoupon) {
                            this.$set(this.studentWallet.studentCoupons, data.studentCoupon.id, data.studentCoupon)
                        }

                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.disputeMoney = data.disputeMoney;
                        this.studentWallet.couponMoney = data.couponMoney;
                        break;
                    case 'askForApplyPeriodError':
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        break;
                    case 'switchingPeriod':
                        this.studentPeriod.switchingPeriod.message = data.switchingPeriod.message;
                        this.studentPeriod.switchingPeriod.loading = false;
                        break;
                    case 'storeAdvisory':
                        this.$message({
                            message: '咨询信息添加成功',
                            type: 'success'
                        });
                        this.studentAdvisory.dialog_AddAdvisory.button_loading = false;
                        if (Object.keys(data.studentAdvisory).length !== 0) {
                            this.studentAdvisory.advisory = data.studentAdvisory
                        } else {
                            this.studentAdvisory.advisory = new Object();
                        }
                        this.studentAdvisory.total = data.studentAdvisory.total;
                        this.$Win.closeModal();
                        break;
                    case 'storeAdvisoryError':
                        this.studentAdvisory.dialog_AddAdvisory.button_loading = false;
                        break;
                    case 'getAdvisoryDetail':
                        this.studentAdvisory.dialog_ShowAdvisory.advisoryDetail = data.studentAdvisory;
                        this.studentAdvisory.dialog_ShowAdvisory.loading = false;
                        break;
                    case 'updateAdvisory':
                        this.$message({
                            message: '咨询信息修改成功',
                            type: 'success'
                        });
                        this.studentAdvisory.dialog_ShowAdvisory.button_loading = false;
                        if (Object.keys(data.studentAdvisory).length !== 0) {
                            this.studentAdvisory.advisory = data.studentAdvisory
                        } else {
                            this.studentAdvisory.advisory = new Object();
                        }
                        this.studentAdvisory.total = data.studentAdvisory.total;
                        this.$Win.closeModal();
                        break;
                    case 'updateAdvisoryError':
                        this.studentAdvisory.dialog_ShowAdvisory.button_loading = false;
                        break;
                    case 'showStudentPeriod':
                        this.studentCourseRecord.dialog_CancelCourse.studentPeriod = data.studentPeriod;
                        this.studentCourseRecord.dialog_CancelCourse.retire_period = data.retire_period;
                        this.studentCourseRecord.dialog_CancelCourse.loading = false;
                        this.studentCourseRecord.dialog_ChangeCourse.studentPeriod = data.studentPeriod;
                        this.studentCourseRecord.dialog_ChangeCourse.retire_period = data.retire_period;
                        this.studentCourseRecord.dialog_ChangeCourse.loading = false;
                        break;
                    case 'updateStudentPeriod':
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.studentCourseRecord.dialog_CancelCourse.button_loading = false;
                        //修改课程记录
                        if (Object.keys(data.studentCourseRecord.studentPeriod_active).length !== 0) {
                            this.studentCourseRecord.studentActivePeriods = data.studentCourseRecord.studentPeriod_active
                        } else {
                            this.studentCourseRecord.studentActivePeriods = new Object();
                        }
                        if (Object.keys(data.studentCourseRecord.studentPeriod_cancel).length !== 0) {
                            this.studentCourseRecord.studentCancelPeriods = data.studentCourseRecord.studentPeriod_cancel
                        } else {
                            this.studentCourseRecord.studentCancelPeriods = new Object();
                        }
                        //修改在读课程
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }
                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.$Win.closeModal();
                        break;
                    case 'updateStudentPeriodError':
                        this.studentCourseRecord.dialog_CancelCourse.button_loading = false;
                        break;
                    case 'changeStudentPeriod':
                        this.studentCourseRecord.dialog_ChangeCourse.button_loading = false;
                        this.$Win.closeModal();
                        this.$Win.openModal('Dialog_ChooseClass', 1000, 900, '选择课程', {
                            'grade_id': this.student.current_education.grade.id,
                            'studentPeriod_id': this.studentCourseRecord.dialog_ChangeCourse.studentPeriod.id,
                            'semester_id': this.$store.state.config.nowSemester.id,
                        }, true);
                        break;
                    case 'changeStudentPeriodError':
                        this.studentCourseRecord.dialog_ChangeCourse.button_loading = false;
                        break;
                    //Dialog_WalletAddCash
                    case 'settleCourses':
                        this.studentWallet.dialog_WallAddCash.settleForm = [];
                        data.payment_types.forEach((item) => {
                            this.studentWallet.dialog_WallAddCash.settleForm.push({
                                name: item.name,
                                id: item.id,
                                balance: 0
                            })
                        });
                        this.studentWallet.dialog_WallAddCash.paymentTypeJudge = true;
                        this.studentWallet.dialog_WallAddCash.loading = false;
                        break;
                    case 'storeStudentBalance':
                        this.$message({
                            message: '充值提现成功',
                            type: 'success'
                        });
                        this.studentWallet.dialog_WallAddCash.button_loading = false;
                        if (Object.keys(data.studentWallet.studentBalances).length !== 0) {
                            this.studentWallet.studentBalances = data.studentWallet.studentBalances
                        } else {
                            this.studentWallet.studentBalances = new Object();
                        }
                        this.studentWallet.hasMoney = data.studentWallet.hasMoney;
                        this.studentWallet.disputeMoney = data.studentWallet.disputeMoney;
                        this.studentWallet.couponMoney = data.studentWallet.couponMoney;
                        this.$Win.closeModal();
                        break;
                    case 'storeStudentBalanceError':
                        this.studentWallet.dialog_WallAddCash.button_loading = false;
                        break;
                    //Dialog_LessonRetied
                    case 'getLessonInWallet':
                        this.studentWallet.dialog_LessonRetired.studentLessons = data.studentLessons;
                        this.studentWallet.dialog_LessonRetired.loading = false;
                        break;
                    case 'get_classHour_in_wallet':
                        if (Object.keys(data.studentClassHours).length !== 0) {
                            this.studentWallet.dialog_ClassHourRetired.studentClassHours = data.studentClassHours;
                        } else {
                            this.studentWallet.dialog_ClassHourRetired.studentClassHours = new Object();
                        }
                        this.studentWallet.dialog_ClassHourRetired.loading = false;
                        break;
                    case 'cancel_studentClassHour':
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.studentWallet.dialog_LessonRetired.button_loading= false;
                        this.$delete(this.studentWallet.dialog_ClassHourRetired.studentClassHours, data.studentClassHour_id);
                        this.$set(this.studentWallet.studentBalances, data.studentBalance.id, data.studentBalance);
                        this.$set(this.studentWallet.studentClassHours, data.studentClassHour.id, data.studentClassHour);
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        break;
                    case 'cancelRetirePeriod':
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.studentWallet.dialog_LessonRetired.button_loading = false;
                        this.studentWallet.dialog_LessonRetired.studentLessons = data.studentLessons;
                        this.$Win.closeModal();
                        if (Object.keys(data.studentWallet.studentBalances).length !== 0) {
                            this.studentWallet.studentBalances = data.studentWallet.studentBalances
                        } else {
                            this.studentWallet.studentBalances = new Object();
                        }
                        if (Object.keys(data.studentWallet.studentLessons).length !== 0) {
                            this.studentWallet.studentPeriods = data.studentWallet.studentLessons
                        } else {
                            this.studentWallet.studentPeriods = new Object();
                        }
                        this.studentWallet.hasMoney = data.studentWallet.hasMoney;
                        this.studentWallet.disputeMoney = data.studentWallet.disputeMoney;
                        this.studentWallet.couponMoney = data.studentWallet.couponMoney;
                        break;
                    case 'cancelRetirePeriodError':
                        this.studentWallet.dialog_LessonRetired.button_loading = false;
                        break;
                    //Dialog_StudentAddEducationalExperiences
                    case 'initStudentInformation':
                        this.initInformation = data;
                        this.loading = false;
                        break;
                    case 'storeEducationExperiences':
                        this.$message({
                            message: '信息添加成功',
                            type: 'success'
                        });
                        this.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.button_loading = false;
                        this.studentEducationalExperiences.educationalExperiences = data.studentEducationalExperiences.studentEducationalExperiences;
                        this.studentEducationalExperiences.total = data.studentEducationalExperiences.total;
                        this.$Win.closeModal();
                        break;
                    case 'storeEducationExperiencesError':
                        this.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.button_loading = false;
                        break;
                    //Dialog_StudentEducationExperiencesDetail
                    case 'showEducationExperiences':
                        this.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail = data.educationalExperiences;
                        this.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.loading = false;
                        break;
                    case 'updateEducationalExperiences':
                        this.$message({
                            message: '信息修改成功',
                            type: 'success'
                        });
                        this.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.button_loading = false;
                        this.studentEducationalExperiences.educationalExperiences = data.studentEducationalExperiences;
                        this.studentEducationalExperiences.total = data.total;
                        this.$Win.closeModal();
                        break;
                    case 'updateEducationalExperiencesError':
                        this.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.button_loading = false;
                        break;
                    //Dialog_AddSchoolScore
                    case 'showStudentSchool':
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.school_id = data.educationalExperiences.school_id;
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.school_name = data.educationalExperiences.school.name;
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.grade_id = data.educationalExperiences.grade_id;
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_id = '';
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_name = '';
                        this.schoolScore.dialog_AddSchoolScore.school_val.schoolExams = data.schoolExams;
                        this.schoolScore.dialog_AddSchoolScore.school_val.examSubjects = [];
                        this.schoolScore.dialog_AddSchoolScore.loading = false;
                        break;
                    case 'getSchoolExamSubjectScore':
                        this.schoolScore.dialog_AddSchoolScore.school_val.examSubjects = [];
                        for (let i = 0; i < Object.keys(data.schoolExam_subject).length; i++) {
                            this.schoolScore.dialog_AddSchoolScore.school_val.examSubjects.push({
                                id: data.schoolExam_subject[i].id,
                                name: data.schoolExam_subject[i].subject.name,
                                subject_id: data.schoolExam_subject[i].subject.id,
                                totalScore: '',
                                score: '',
                                areaAvgScore: data.schoolExam_subject[i].areaAvgScore,
                                gradeAvgScore: data.schoolExam_subject[i].gradeAvgScore,
                                classAvgScore: data.schoolExam_subject[i].classAvgScore,
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                                cityRank: '',
                            })
                        }
                        this.schoolScore.dialog_AddSchoolScore.subjectCheck = true;
                        this.schoolScore.dialog_AddSchoolScore.loading = false;
                        break;
                    case 'getSchoolExam':
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_id = '';
                        this.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_name = '';
                        this.schoolScore.dialog_AddSchoolScore.school_val.schoolExams = data.schoolExams;
                        this.schoolScore.dialog_AddSchoolScore.school_val.examSubjects = [];
                        this.schoolScore.dialog_AddSchoolScore.loading = false;
                        break;
                    case 'addStudentScore':
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.schoolScore.dialog_AddSchoolScore.button_loading = false;
                        if (Object.keys(data.student_schoolExam.student_schoolExams).length !== 0) {
                            this.schoolScore.schoolScores = data.student_schoolExam.student_schoolExams
                        } else {
                            this.schoolScore.schoolScores = new Object();
                        }
                        // if (Object.keys(data.student_schoolExam.organizationServiceScores).length !== 0) {
                        //     this.schoolScore.organizationServiceScores = data.student_schoolExam.organizationServiceScores
                        // } else {
                        //     this.schoolScore.organizationServiceScores = new Object();
                        // }
                        this.$Win.closeModal();
                        break;
                    case 'addStudentScoreError':
                        this.schoolScore.dialog_AddSchoolScore.button_loading = false;
                        break;
                    case 'showStudentExam':
                        this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam = data.student_schoolExam;
                        if (this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class == null) {
                            this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class = {
                                id: 0,
                                schoolClass_id: '',
                                mainClassAvgScore: '',
                                sumClassAvgScore: '',
                            }
                        }
                        this.schoolScore.dialog_UpdateMainSchoolScore.loading = false;
                        break;
                    case 'updateSchoolExam':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.schoolScore.dialog_UpdateMainSchoolScore.button_loading = false;
                        this.$set(this.schoolScore.schoolScores, data.student_schoolExam.id, data.student_schoolExam);
                        this.$Win.closeModal();
                        break;
                    case 'updateSchoolExamError':
                        this.schoolScore.dialog_UpdateMainSchoolScore.button_loading = false;
                        break;
                    //Dialog_ChooseCoupon
                    case 'chooseCoupon':
                        if (Object.keys(data.studentCoupons).length > 0) {
                            this.studentCart.dialog_ChooseCoupon.studentCoupons = data.studentCoupons;
                        } else {
                            this.studentCart.dialog_ChooseCoupon.studentCoupons = new Object();
                        }
                        this.studentCart.dialog_ChooseCoupon.coupon_ids = data.cartCoupon;
                        this.studentCart.dialog_ChooseCoupon.loading = false;
                        break;
                    case 'storeCartCoupon':
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                            for (let i in this.studentCart.studentCartData) {
                                this.studentCart.studentCartData[i].chosen = true
                            }
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        this.studentCart.dialog_ChooseCoupon.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'storeCartCouponError':
                        this.studentCart.dialog_ChooseCoupon.button_loading = false;
                        break;
                    //Dialog_ChooseWanTuoClassPlan
                    case 'getClassPlan':
                        if (Object.keys(data.studentCartClassPlans).length > 0) {
                            this.studentCart.studentCart_classPlans = data.studentCartClassPlans;
                        } else {
                            this.studentCart.studentCart_classPlans = new Object()
                        }
                        this.studentCart.dialog_ChooseClassPlan.loading = false;
                        this.studentCart.dialog_ChooseWanTuoClassPlan.loading = false;
                        break;
                    case 'get_student_wanTuoClassPlan':
                        if (Object.keys(data.studentCartClassPlans).length > 0) {
                            this.studentCart.studentCart_classPlans = data.studentCartClassPlans;
                        } else {
                            this.studentCart.studentCart_classPlans = new Object()
                        }
                        this.studentCart.dialog_ChooseClassPlan.loading = false;
                        this.studentCart.dialog_ChooseWanTuoClassPlan.loading = false;
                        break;
                    case 'selectClassPlan':
                        if (Object.keys(data.getClassPlan).length > 0) {
                            this.studentCart.studentCart_classPlans = data.getClassPlan;
                        } else {
                            this.studentCart.studentCart_classPlans = new Object()
                        }
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        this.$message({
                            message: '挑选课时成功',
                            type: 'success'
                        });
                        this.studentCart.dialog_ChooseClassPlan.button_loading = false;
                        this.studentCart.dialog_ChooseWanTuoClassPlan.button_loading = false;
                        break;
                    case 'select_wanTuoClassPlan':
                        if (Object.keys(data.studentCartClassPlans).length > 0) {
                            this.studentCart.studentCart_classPlans = data.studentCartClassPlans;
                        } else {
                            this.studentCart.studentCart_classPlans = new Object()
                        }
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        this.$message({
                            message: '挑选课时成功',
                            type: 'success'
                        });
                        this.studentCart.dialog_ChooseClassPlan.button_loading = false;
                        this.studentCart.dialog_ChooseWanTuoClassPlan.button_loading = false;
                        break;
                    case 'selectClassPlanError':
                        this.studentCart.dialog_ChooseClassPlan.button_loading = false;
                        this.studentCart.dialog_ChooseWanTuoClassPlan.button_loading = false;
                        break;
                    //Dialog_DiscountTye
                    case 'get_discountTypes':
                        // this.studentCart.sumPay = 0;
                        if (Object.keys(data.discountTypes).length > 0) {
                            this.studentCart.dialog_DiscountType.discountTypes = JSON.parse(JSON.stringify(data.discountTypes));
                            this.studentCart.dialog_DiscountType.standbyDiscountTypes = JSON.parse(JSON.stringify(data.discountTypes));
                            this.studentCart.dialog_DiscountType.discountType_details = data.discountType_details;
                            this.studentCart.studentCartData = data.studentCarts;
                        } else {
                            this.studentCart.dialog_DiscountType.discountTypes = new Object();
                            this.studentCart.dialog_DiscountType.standbyDiscountTypes = new Object();
                            this.studentCart.dialog_DiscountType.discountType_details = new Object();
                        }
                        this.studentCart.dialog_DiscountType.selfDiscounts = data.selfDiscounts;
                        this.studentCart.dialog_DiscountType.selfCashDiscount = data.installmentSelfCashDiscounts;
                        this.studentCart.dialog_DiscountType.selfCashDiscounts = data.selfCashDiscounts + data.installmentSelfCashDiscounts;

                        this.studentCart.dialog_DiscountType.selfOfflineCashDiscounts = data.selfOfflineCashDiscounts+ data.installmentSelfCashDiscounts;
                        this.studentCart.dialog_DiscountType.selfOnlineCashDiscounts = data.selfOnlineCashDiscounts+ data.installmentSelfCashDiscounts;


                        this.studentCart.dialog_DiscountType.installmentSelfCashDiscounts = data.installmentSelfCashDiscounts;
                        this.studentCart.dialog_DiscountType.discounts = data.discounts;
                        // this.studentCart.sumPay = data.sumPay;
                        this.studentCart.dialog_DiscountType.canUseDiscounts = true;
                        this.studentCart.dialog_DiscountType.loading = false;
                        this.studentCart.chosenCart.forEach((item) => {
                            if (this.studentCart.studentCartData[item].installment != 0) {
                                this.studentCart.dialog_DiscountType.canUseDiscounts = false;
                            }
                        });
                        if (Object.keys(data.cartPayments).length > 0) {
                            this.studentCart.dialog_SettleAccounts.payments=data.cartPayments
                        }else {
                            this.studentCart.dialog_SettleAccounts.payments= new Object()
                        }
                        this.studentCart.dialog_SettleAccounts.studentDeposits=data.studentDeposits
                        if (data.type === 'belowNow') {
                            this.$message.warning(data.msg);
                            this.studentCart.dialog_DiscountType.canUseDiscounts = false;
                        }
                        this.studentCart.dialog_SettleAccounts.payUrl=data.payUrl

                        this.$forceUpdate();
                        break;
                    case 'get_discountTypes_error':
                        if (data.msg === '不能同时买三学期以上课程') {
                            this.$Win.closeModal();
                            this.studentCart.dialog_DiscountType.loading = false;
                        }
                        this.$parentInfo.studentCart.chosenCart.forEach((item) => {
                            if (this.$parentInfo.studentCart.studentCartData[item].installment != 0) {
                                this.studentCart.dialog_DiscountType.canUseDiscounts = false;
                                this.$message.warning('分期不能使用优惠券');
                            }
                        });
                        break;
                    case 'store_cart_discount':
                        this.studentCart.discountChange = true;
                        // this.studentCart.sumPay = 0;
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                            this.studentCart.sumPay = data.sumPay;
                            // this.studentCart.chosenCart.forEach((item) => {
                            //     this.studentCart.sumPay += this.studentCart.studentCartData[item].sum_price;
                            // });
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        if (data.discount != 0) {
                            this.studentCart.installCheck = false;
                        } else {
                            this.studentCart.installCheck = true;
                        }
                        for (const key in this.studentCart.dialog_SettleAccounts.payments) {
                            if (this.studentCart.dialog_SettleAccounts.payments[key].paymentType_id==5) {
                                this.studentCart.dialog_SettleAccounts.payments[key].balance=data.discount;
                                break;
                            }
                        }
                        //this.studentCart.invoiceForm.payment_types[5].balance = data.discount;
                        this.studentCart.dialog_DiscountType.button_loading = false;
                        this.studentCart.installCheck = true;
                        // this.$Win.closeModal();
                        break;
                    case 'store_cart_discount_error':
                        this.studentCart.dialog_DiscountType.button_loading = false;
                        this.studentCart.installCheck = true;
                        break;
                    //Dialog_ChooseLesson
                    case 'getLessonInCart':
                        this.studentCart.dialog_ChooseLesson.studentCarts = data.getLessonInCart.studentCarts;
                        this.studentCart.dialog_ChooseLesson.studentLessons = data.getLessonInCart.studentLessons;
                        this.studentCart.dialog_ChooseLesson.loading = false;
                        break;
                    case 'checkCart':
                        this.studentCart.invoiceForm.payment_types[9].balance = data.check.period_money;
                        this.studentCart.cart_use_lessons = data.check.cart_use_lessons;
                        this.studentCart.dialog_ChooseLesson.button_loading = false;
                        this.studentCart.settleJudge = true;
                        this.$Win.closeModal();
                        break;
                    case 'checkCartError':
                        this.studentCart.dialog_ChooseLesson.button_loading = false;
                        this.studentCart.settleJudge = false;
                        break;
                    //Dialog_ChooseClassPlan
                    //Dialog_DiscountCourse
                    case 'changeDiscount':
                        this.$message({
                            message: '打折成功',
                            type: 'success'
                        });
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        this.studentCart.dialog_DiscountCourse.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'changeDiscountError':
                        this.studentCart.dialog_DiscountCourse.button_loading = false;
                        break;
                    //Dialog_HasTime
                    case 'changeTime':
                        this.$message({
                            message: '占用成功',
                            type: 'success'
                        });
                        this.studentCart.dialog_HasTime.button_loading = false;
                        this.$Win.closeModal();
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        break;
                    case 'changeTimeError':
                        this.studentCart.dialog_HasTime.button_loading = false;
                        break;
                    //Dialog_Installment
                    case 'changeInstallment':
                        this.$message({
                            message: '分期成功',
                            type: 'success'
                        });
                        if (Object.keys(data.changeInstallment.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.changeInstallment.studentCarts;
                            for (let i in this.studentCart.studentCartData) {
                                this.studentCart.studentCartData[i].chosen = true
                            }
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        this.studentCart.sumPay = data.changeInstallment.real_money;
                        if (Object.keys(data.changeInstallment.getDiscountTypes.discountTypes).length > 0) {
                            this.studentCart.dialog_DiscountType.discountTypes = JSON.parse(JSON.stringify(data.changeInstallment.getDiscountTypes.discountTypes));
                            this.studentCart.dialog_DiscountType.standbyDiscountTypes = JSON.parse(JSON.stringify(data.changeInstallment.getDiscountTypes.discountTypes));
                            this.studentCart.dialog_DiscountType.discountType_details = data.changeInstallment.getDiscountTypes.discountType_details;
                            this.studentCart.studentCartData = data.changeInstallment.getDiscountTypes.studentCarts;
                        } else {
                            this.studentCart.dialog_DiscountType.discountTypes = new Object();
                            this.studentCart.dialog_DiscountType.standbyDiscountTypes = new Object();
                            this.studentCart.dialog_DiscountType.discountType_details = new Object();
                        }
                        this.studentCart.dialog_DiscountType.installmentSelfCashDiscounts = this.studentCart.dialog_DiscountType.selfCashDiscount;
                        this.studentCart.innerVisible = false;
                        this.studentCart.dialog_DiscountType.canUseDiscounts = false;
                        this.studentCart.dialog_Installment.button_loading = false;
                        break;
                    case 'changeInstallmentError':
                        this.studentCart.dialog_Installment.button_loading = false;
                        break;
                    //studentInvoice
                    case 'invoiceDetail':
                        this.dialog_InvoiceDetail.showOn = true;
                        this.dialog_InvoiceDetail.invoiceDetail_val = data.studentInvoice;
                        this.dialog_InvoiceDetail.loading = false;
                        break;
                    case 'anotherInvoiceDetail':
                        this.dialog_InvoiceDetail.showOn = true;
                        this.dialog_InvoiceDetail.anotherInvoiceDetail_val = data.studentInvoice;
                        this.dialog_InvoiceDetail.loading = false;
                        break;
                    case 'leaseInvoiceDetail':
                        this.dialog_InvoiceDetail.showOn = true;
                        this.dialog_InvoiceDetail.leaseInvoiceDetail_val = data.studentInvoice;
                        this.dialog_InvoiceDetail.loading = false;
                        break;
                    case 'invoiceBill':
                        this.dialog_InvoiceBill.invoiceBills = data.invoiceBills;
                        this.dialog_InvoiceBill.invoiceBillsLength = Object.keys(data.invoiceBills).length;
                        this.dialog_InvoiceBill.loading = false;
                        break;
                    case 'cancelInvoice':
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.$set(this.studentCourseRecord.studentInvoice.studentInvoices, data.studentInvoice.id, data.studentInvoice);
                        break;
                    //修改学生信息
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchStudent':
                        this.students = data.searchData.students;
                        break;
                    case 'updateStudentInformation':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.dialog_ChangeInformation.button_loading = false;
                        this.student = JSON.parse(JSON.stringify(data.student));
                        this.dialog_ChangeInformation.student = JSON.parse(JSON.stringify(data.student));
                        this.dialog_ChangeInformation.student.headTeachers = [];
                        this.dialog_ChangeInformation.student.subjects = [];
                        JSON.parse(JSON.stringify(data.student.headTeachers)).forEach((item) => {
                            this.dialog_ChangeInformation.student.headTeachers.push(item.id)
                        });
                        JSON.parse(JSON.stringify(data.student.subjects)).forEach((item) => {
                            this.dialog_ChangeInformation.student.subjects.push(item.id);
                        });
                        this.$Win.closeModal();
                        break;
                    case 'updateStudentInformationError':
                        this.dialog_ChangeInformation.button_loading = false;
                        break;
                    //添加班级课表
                    case 'showTable':
                        this.timeData = data.timeData;
                        this.subjects = data.subjects;
                        this.teachers = data.teachers;
                        this.classes = data.classes;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.class_types = data.class_types;
                        this.semesters = data.semesters;
                        this.gradesInfo = data.grades;
                        this.start_date = data.start_date;
                        this.tempLength = data.tempLength;
                        this.filter.section_id = data.section_id;
                        this.V4Judge = true;
                        this.loading = false;
                        this.dialog_ChooseClass_loading = false;
                        break;
                    case 'get_student_carts_to_timeTable':
                        this.studentCarts = data.studentCarts;
                        this.dialog_ChooseClass_loading = false;
                        break;
                    case 'add_class_to_cart':
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        this.studentPeriod.studentActivePeriods[2].push(data.studentCartItems[0]);
                        Object.keys(this.studentCarts).forEach((item, index) => {
                            if (index === data.studentCart_tidy.sortBy) {
                                this.studentCarts[index][0].name = data.studentCart_tidy.name;
                                this.studentCarts[index][0].cart_id = data.studentCart_tidy.id;
                            }
                        });
                        this.$message({
                            type: 'success',
                            message: '添加购物车成功!'
                        });
                        break;
                    case 'store_class':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        if (!this.classes[this.cell.teacher_id]) {
                            this.$set(this.classes, this.cell.teacher_id, []);
                        }
                        this.$set(this.classes[this.cell.teacher_id], this.cell.template_time_id, [data.createInfo]);
                        this.dialog_CreateClass_Semester.button_loading = false;
                        this.dialog_CreateClass_Semester.cartTableDialogVisible = false;
                        break;
                    case 'store_class_error':
                        this.dialog_CreateClass_Semester.button_loading = false;
                        break;
                    case 'get_course':
                        if (data.type === 'create') {
                            this.dialog_CreateClass_Semester.courses = data.courses;
                            if (this.dialog_CreateClass_Semester.classForm.subject_id === 24) {
                                this.dialog_CreateClass_Semester.classForm.name = '晚托';
                                this.dialog_CreateClass_Semester.classForm.period = data.course_count;
                            } else {
                                this.dialog_CreateClass_Semester.course = data.course;
                                if (data.course) {
                                    this.dialog_CreateClass_Semester.classForm.period = data.course.period;
                                }
                                this.dialog_CreateClass_Semester.classForm.name = this.grades[this.dialog_CreateClass_Semester.classForm.grade_id].name +
                                    this.subjects[this.cell.subject_id].name;
                            }
                        }
                        break;
                    case 'search_classroom':
                        this.classrooms = data.classrooms;
                        this.dialog_CreateClass_Semester.search_loading = false;
                        break;
                    //获取课程
                    case 'get_classrooms':
                        this.classrooms = data.classrooms;
                        this.dialog_ChooseClass_loading = false;
                        break;
                    //获取余额详情
                    case 'get_balanceDetail':
                        this.studentWallet.dialog_BalanceDetail.balanceDetails = data.balanceDetails;
                        break;
                    case 'get_balanceDetail_error':
                        // this.studentWallet.dialog_BalanceDetail = data.balanceDetails;
                        break;
                    case 'get_invoiceRefund':
                        this.studentWallet.dialog_BalanceDetail.invoiceRefunds = data.invoiceRefunds;
                        break;
                    case 'give_refund_to_student':
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.studentWallet.hasMoney = this.studentWallet.hasMoney - data.refundMoney;
                        this.studentWallet.dialog_BalanceDetail.loading = false;
                        this.studentWallet.dialog_BalanceDetail.showInvoiceRefund = false;
                        break;
                    case 'give_refund_to_student_error':
                        this.studentWallet.dialog_BalanceDetail.loading = false;
                        break;
                    case 'cancelRefund':
                        this.$message({
                            message: '撤回成功',
                            type: 'success'
                        });

                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }

                        if (data.new_studentBalance) {
                            this.$set(this.studentWallet.studentBalances, data.new_studentBalance.id, data.new_studentBalance)
                        }

                        if (data.old_studentBalance) {
                            this.$set(this.studentWallet.studentBalances, data.old_studentBalance.id, data.old_studentBalance)
                        }

                        if (data.studentCoupon) {
                            this.$set(this.studentWallet.studentCoupons, data.studentCoupon.id, data.studentCoupon)
                        }

                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.disputeMoney = data.disputeMoney;
                        this.studentWallet.couponMoney = data.couponMoney;
                        break;
                    case 'show_weekTable':
                        this.studentWeekTable.classes = data.classes;
                        this.studentWeekTable.weeks = data.weeks;
                        this.studentWeekTable.basisTime = data.basisTime;
                        this.studentWeekTable.V4Show = true;
                        this.studentWeekTable.loading = false;
                        this.studentWeekTable.V4Judge = true;
                        break;
                    case 'classHour_cart_init':
                        this.dialog_classHourCart.semesters = data.semesters
                        this.dialog_classHourCart.grades = data.grades
                        break;
                    case 'search_classHour':
                        this.dialog_classHourCart.classHours = data.classHours
                        break;
                    case 'add_classHour_to_cart':
                        this.$set(this.studentCart.studentCartClassHourData, data.studentCart_classHour.id, data.studentCart_classHour)
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        break;
                    case 'get_discount_to_cart_classHour':
                        this.$message({
                            message: '打折成功',
                            type: 'success'
                        });
                        this.$set(this.studentCart.studentCartClassHourData, data.studentCart_classHour.id, data.studentCart_classHour)
                        this.studentCart.dialog_DiscountClassHour.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'delete_classHour_to_cart':
                        this.$delete(this.studentCart.studentCartClassHourData, data.cart_classHour_id)
                        this.studentCart.button_loading = false;
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        break;
                    case 'get_shops':
                        this.dialog_shopCart.shops = data.shops
                        break;
                    case 'search_shops':
                        this.dialog_shopCart.shops = data.shops
                        break;
                    case 'add_shop_to_cart':
                        this.$set(this.studentCart.studentCartShopData, data.studentCart_shop.id, data.studentCart_shop)
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        break;
                    case 'get_discount_to_cart_shop':
                        this.$message({
                            message: '打折成功',
                            type: 'success'
                        });
                        this.$set(this.studentCart.studentCartShopData, data.studentCart_shop.id, data.studentCart_shop)
                        this.studentCart.dialog_DiscountShop.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'delete_shop_to_cart':
                        this.$delete(this.studentCart.studentCartShopData, data.cart_shop_id)
                        this.studentCart.button_loading = false;
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        break;
                    case 'settle_anotherAccount':
                        this.$message({
                            message: '结算成功，成功创建合同',
                            type: 'success'
                        });
                        this.studentCart.button_loading = false;
                        for (let i in data.cart_classHour_ids) {
                            this.$delete(this.studentCart.studentCartClassHourData, data.cart_classHour_ids[i])
                        }
                        for (let j in data.cart_shop_ids) {
                            this.$delete(this.studentCart.studentCartShopData, data.cart_shop_ids[j])
                        }
                        for (let k in data.studentClassHours) {
                            this.$set(this.studentWallet.studentClassHours, data.studentClassHours[k].id, data.studentClassHours[k])
                        }
                        for (let l in data.studentShops) {
                            this.$set(this.studentWallet.studentShops, data.studentShops[l].id, data.studentShops[l])
                        }
                        this.$Win.closeModal();
                        this.$Win.openModal('Dialog_AnotherInvoiceDetail', 760, 800, '合同详情', {
                            'invoice_id': data.invoice_id,
                        });
                        break;
                    case 'get_studentClassHour_from_cart_id':
                        this.studentCart.dialog_UseClassHour.semesters = data.semesters
                        this.studentCart.dialog_UseClassHour.studentClassHours = JSON.parse(JSON.stringify(data.studentClassHours))
                        break;
                    case 'search_studentClassHour':
                        var studentClassHours = data.studentClassHours
                        for (let j in this.studentCart.dialog_UseClassHour.filters) {
                            this.$delete(studentClassHours, this.studentCart.dialog_UseClassHour.filters[j].studentClassHour_id)
                        }
                        this.studentCart.dialog_UseClassHour.filters[data.index].studentClassHours = studentClassHours
                        break;
                    case 'use_studentClassHour_to_cart':
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart)
                        this.$Win.closeModal();
                        break;
                    case 'studentFinishedPeriod':
                        this.$delete(this.studentCourseRecord.studentActivePeriods,data.studentPeriod_id);
                        break;
                    case 'searchSchool':
                        this.initInformation.schools=data.searchData.searchData;
                        break;
                    case 'get_studentAccount':
                        this.dialog_ChangeStudentPhone.phone=data.phone
                        break;
                    case 'get_studentAccount_error':
                        break;
                    case 'update_studentAccount':
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        this.dialog_ChangeStudentPhone.button_loading=false
                        break;
                    case 'update_studentAccount_error':
                        this.dialog_ChangeStudentPhone.button_loading=false
                        break;
                    case 'binding_account_from_student_id':
                        this.$message({
                            message: '绑定成功',
                            type: 'success'
                        });
                        break;
                    case 'changeCoupon':
                        this.studentWallet.couponMoney=data.couponMoney
                        this.studentWallet.sum_cashCoupon=data.sum_cashCoupon
                        if (data.studentCashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.studentCashCoupon.id, data.studentCashCoupon)
                        }
                        if (data.studentCoupon) {
                            this.$set(this.studentWallet.studentCoupons, data.studentCoupon.id, data.studentCoupon)
                        }
                        break;
                    case 'storeStudentCashCoupon':
                        this.studentWallet.sum_cashCoupon=data.sum_cashCoupon
                        if (data.studentCashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.studentCashCoupon.id, data.studentCashCoupon)
                        }
                        this.studentWallet.dialog_UpdateCashCoupon.button_loading=false;
                        break;
                    case 'storeStudentCashCoupon_error':
                        this.studentWallet.dialog_UpdateCashCoupon.button_loading=false;
                        break;
                    case 'get_next_semesters':
                        this.studentWallet.dialog_ClassHourChange.next_semesters=data.semesters
                        break;
                    case 'change_studentClassHour':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        for(let i=1;i<data.studentClassHours.length;i++){
                            this.$set(this.studentWallet.studentClassHours, data.studentClassHours[i].id, data.studentClassHours[i]);
                        }
                        this.studentWallet.dialog_ClassHourChange.dialogVisible=false
                        break;
                    case 'cart_change_to_trying':
                        this.$message({
                            message: '转化成功',
                            type: 'success'
                        });
                        this.studentCart.discountChange = false;
                        Object.keys(this.studentCarts).forEach((item, index) => {
                            if (index === data.sortBy) {
                                this.studentCarts[index][0].name = '';
                                this.studentCarts[index][0].cart_id = '';
                            }
                        });
                        this.studentPeriod.studentActivePeriods[2].forEach((item, index) => {
                            if (item.class_id == data.class_id) {
                                this.studentPeriod.studentActivePeriods[2].splice(index, 1);
                            }
                        });
                        if (Object.keys(data.studentCarts).length !== 0) {
                            this.studentCart.studentCartData = data.studentCarts;
                        } else {
                            this.studentCart.studentCartData = new Object();
                        }
                        this.$message({
                            type: 'success',
                            message: '移除成功',
                        });
                        this.$forceUpdate();
                        this.studentCart.button_loading = false;
                        break;
                    case 'get_student_trying_cart':
                        this.dialog_TryingCart.tryingCarts=data.tryingCarts
                        this.dialog_TryingCart.loading=false
                        break;
                    case 'restore_student_trying_cart':
                        this.$delete(this.dialog_TryingCart.tryingCarts, data.studentCart.id);
                        this.$set(this.studentCart.studentCartData, data.studentCart.id, data.studentCart);
                        this.studentPeriod.studentActivePeriods[2].push(data.studentCartItems[0]);
                        Object.keys(this.studentCarts).forEach((item, index) => {
                            if (index === data.studentCart_tidy.sortBy) {
                                this.studentCarts[index][0].name = data.studentCart_tidy.name;
                                this.studentCarts[index][0].cart_id = data.studentCart_tidy.id;
                            }
                        });
                        this.$message({
                            type: 'success',
                            message: '转化成功!'
                        });
                        this.dialog_TryingCart.button_loading=false
                        break;
                    case 'restore_student_trying_cart_error':
                        this.dialog_TryingCart.button_loading=false
                        break;
                    case 'add_cart_payment':
                        this.$set(this.studentCart.dialog_SettleAccounts.payments,data.cartPayment.id,data.cartPayment);
                        break;
                    case 'del_cart_payment':
                        this.$delete(this.studentCart.dialog_SettleAccounts.payments,data.cart_payment_id);
                        break;
                    case 'refresh_cart_payment':
                        this.$set(this.studentCart.dialog_SettleAccounts.payments,data.cartPayment.id,data.cartPayment);
                        break;
                    case 'get_settlementInvoice':
                        if (Object.keys(data.settlementInvoices).length !== 0) {
                            this.NoSettlementInvoice.settlementInvoices=data.settlementInvoices
                        } else {
                            this.NoSettlementInvoice.settlementInvoices = new Object();
                        }
                        break;
                    case 'get_settlementInvoice_detail':
                        this.NoSettlementInvoice.dialog_settlementInvoiceDetail.carts=data.carts
                        this.NoSettlementInvoice.dialog_settlementInvoiceDetail.discounts=data.discounts
                        this.NoSettlementInvoice.dialog_settlementInvoiceDetail.cashDiscounts=data.cashDiscounts
                        this.NoSettlementInvoice.dialog_settlementInvoiceDetail.otherDiscounts=data.otherDiscounts
                        break;
                    case 'give_carts_to_settlementInvoice':
                        this.$message({
                            message: '转移成功',
                            type: 'success'
                        });
                        for (let i in this.studentCart.invoiceForm.payment_types) {
                            this.studentCart.invoiceForm.payment_types[i].balance = 0;
                        }
                        //刷新购物车
                        for (let l in data.cart_ids) {
                            this.$delete(this.studentCart.studentCartData,data.cart_ids[l])
                        }

                        for (let j in data.cart_classHour_ids) {
                            this.$delete(this.studentCart.studentCartClassHourData,data.cart_classHour_ids[j])
                        }
                        for (let k in data.cart_shop_ids) {
                            this.$delete(this.studentCart.studentCartShopData,data.cart_shop_ids[k])
                        }

                        this.studentCart.settleJudge = false;
                        this.studentCart.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'return_settlementInvoice_to_carts':
                        this.$delete(this.NoSettlementInvoice.settlementInvoices,data.settlementInvoice_id)
                        this.studentCart.settleJudge = false;
                        this.studentCart.button_loading = false;
                        break;
                    case 'clean_cart_select':
                        this.studentCart.dialog_SettleAccounts.payments= new Object()
                        this.equipmentLeasing.paymentTypes=data.paymentTypes
                        this.earnest.paymentTypes=data.paymentTypes
                        break;
                    case 'settlement_cart_shop':
                        this.equipmentLeasing.type=''
                        this.equipmentLeasing.settleDialogVisible=false;
                        this.$Win.closeModal();
                        this.$message({
                            message: '结算成功',
                            type: 'success'
                        });
                        this.$Win.openModal('Dialog_LeaseInvoiceDetail', 760, 800, '合同详情', {
                            'invoice_id': data.invoice_id,
                        });
                        break;
                    case 'student_rent_shop':
                        this.dialog_shopCart.student_rent_shops=data.student_rent_shops
                        break;
                    case 'settlement_earnest':
                        this.$message({
                            message: '结算成功',
                            type: 'success'
                        });
                        if(data.studentEarnestInvoice.prefix=='C'){
                            this.$Win.openModal('Dialog_EarnestAInvoiceDetail', 760, 800, '定金合同详情', {
                                'invoice': data.studentEarnestInvoice,
                            });
                        }else if(data.studentEarnestInvoice.prefix=='B'){
                            this.$Win.openModal('Dialog_EarnestBInvoiceDetail', 760, 800, '定金合同详情', {
                                'invoice': data.studentEarnestInvoice,
                            });
                        }
                        break;
                }
            },
            handleCopyCourseNotify() {
                this.$wApi.send(this.path, 'copyCourseNotify');
            },
            courseStatusSure(student_id) {
                this.$confirm('确认先前课程变动已发送学生?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'courseStatusSure', {
                        'student_id': student_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleAddClass() {
                this.$Win.openModal('Dialog_ChooseClass', 1000, 900, '选择课程', {
                    'grade_id': this.student.current_education.grade.id,
                    'studentPeriod_id': 0,
                    'semester_id': this.$store.state.config.nowSemester.id,
                }, true);
            },
            handleAddAudition() {
                this.$Win.openModal('Dialog_ChooseSpecialClass', 1000, 900, '选择课程', {
                    'grade_id=': this.student.current_education.grade.id,
                    'studentPeriod_id': 0,
                    'semester_id': this.$store.state.config.nowSemester.id
                }, true);
            },
            handleChangeInformation() {
                this.$Win.openModal('Dialog_ChangeInformation', 800, 800, '修改学生');
            },
            handleChangePhone(){
                this.$Win.openModal('Dialog_ChangeStudentPhone', 400, 800, '修改账号');
            },
            handleBindAccount(){
                this.$confirm('确认绑定?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'binding_account_from_student_id', {
                        'student_id': this.student.id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleFile() {
                this.$store.dispatch('addView', {
                    'title': this.student.name + "档案",
                    'path': '/student/' + this.student.id + '/file',
                    'closable': true
                });
                this.router.push({path: '/student/' + this.student.id + '/file'})
            },
            handleEquipmentLeasing(){
                this.$Win.openModal('Dialog_EquipmentLeasing', 800, 500, '设备租赁', {});
            },
            handleEarnest(){
                this.$Win.openModal('Dialog_Earnest', 500, 500, '定金', {});
            },
            handleWeekTable() {
                this.$Win.openModal('Dialog_StudentWeekTable', 1000, 900, '周课表', {}, true);
            },
            handleMonthTable() {
                this.$Win.openModal('Dialog_StudentMonthTable', 1000, 900, '月课表', {}, true);
            },
            handleClassHourCart() {
                this.$Win.openModal('Dialog_ClassHourCart', 400, 500, '课次购买', {});
            },
            handleShopCart() {
                this.$Win.openModal('Dialog_ShopCart', 400, 600, '商品购买', {});
            },
            onCopy() {
                this.$notify({
                    title: '复制成功',
                    message: '内容已复制至剪切板',
                    type: 'success'
                });
            },
            onError() {
                this.$notify({
                    title: '复制失败',
                    message: '请联系程序员',
                    type: 'error'
                });
            },
        }
    };
</script>
